// extracted by mini-css-extract-plugin
export var card = "style-module--card--LxjnE";
export var cardContainer = "style-module--card-container--Hi7kU";